import { Box, styled } from '@mui/material';
import { COLORS } from '../HighlightedPriceDay/constants';

const StyledPriceLegendFooter = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  gap: theme.spacing(1),
  borderTop: `1px solid ${theme.palette.divider}`,

  '& .LDBColorKeyContainer': {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'center',
  },

  '& .LDBColorCaption': {
    fontSize: theme.typography.pxToRem(12),
    maxWidth: theme.spacing(36),
    color: theme.palette.grey[400],
  },
}));

type PriceVariant = keyof typeof COLORS;

interface StyledColorBoxProps {
  variant: PriceVariant;
}

export const StyledColorBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<StyledColorBoxProps>(({ theme, variant }) => ({
  padding: theme.spacing(0.5, 1),
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.common.white,
  backgroundColor: COLORS[variant] || theme.palette.primary.main,
}));

export default StyledPriceLegendFooter;
